import { render, staticRenderFns } from "./pedidosVendas.vue?vue&type=template&id=0bcecc5c&scoped=true&"
import script from "./pedidosVendas.vue?vue&type=script&lang=js&"
export * from "./pedidosVendas.vue?vue&type=script&lang=js&"
import style0 from "./pedidosVendas.vue?vue&type=style&index=0&id=0bcecc5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcecc5c",
  null
  
)

export default component.exports